import { PaginationState } from 'app/shared/pagination/pagination.model';
import axios from 'axios';
import {
  ChamberMemberOverviewFilterModel,
  ChamberMemberOverviewRow,
} from 'app/edozvola/chamber-member-overview/model/chamber-member-overview.model';

export const fetchChamberMemberOverview = async (pagination: PaginationState, filterDto: ChamberMemberOverviewFilterModel): Promise<ChamberMemberOverviewRow[]> => {
  return await new Promise((resolve, reject) => {
    axios.post(`/api/chamber-member-overview?page=${pagination.page}&size=${pagination.size}&column=${pagination.column}&direction=${pagination.direction}`, filterDto)
      .then(res => {
        resolve(res.data);
      })
      .catch(error => {
        reject(error);
      })
  });
};
